(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gkikz-cart-drawer-style"] && !Shopify.designMode) return;
  try {
    (() => {
    const cleanMoneyText = (value) => {
      const template = document.createElement('template');

      template.innerHTML = value || '';

      return (template.content.textContent || value || '').replace(/\s+/g, ' ').trim();
    };

    const syncDiscountPresentation = () => {
      document.querySelectorAll('#cart-drawer .cart-drawer__summary').forEach((summary) => {
        const totals = summary.querySelector('.cart-totals');
        const totalRow = summary.querySelector('.cart-totals__total');
        const totalValue = summary.querySelector('.cart-totals__total-value');
        const source = summary.querySelector('.gkikz-cart-discount-source');
        let original = summary.querySelector('.cart-totals__original-container');

        if (!totals || !totalRow || !totalValue) {
          return;
        }

        const sourceOriginal = cleanMoneyText(source?.dataset.originalPrice);
        const sourceDiscounted = cleanMoneyText(source?.dataset.discountedPrice);

        if (!original && sourceOriginal) {
          original = document.createElement('span');
          original.className = 'cart-totals__original-container';
          totals.prepend(original);
        }

        if (original && !original.textContent.trim() && sourceOriginal) {
          original.textContent = sourceOriginal;
        }

        if (sourceDiscounted && totalValue.textContent.trim() !== sourceDiscounted) {
          const money = totalValue.querySelector('.money');

          if (money) {
            money.textContent = sourceDiscounted;
          } else {
            totalValue.textContent = sourceDiscounted;
          }
        }

        if (original?.textContent.trim() && original.parentElement !== totalRow) {
          original.classList.add('gkikz-cart-original-inline');
          totalRow.insertBefore(original, totalValue);
        }
      });
    };

    const syncRecommendations = () => {
      document.querySelectorAll('#cart-drawer .gkikz-cart-recs').forEach((details) => {
        if (!details.dataset.gkikzUserToggled) {
          details.open = false;
        }
      });
    };

    document.addEventListener(
      'toggle',
      (event) => {
        if (event.target.matches('#cart-drawer .gkikz-cart-recs')) {
          event.target.dataset.gkikzUserToggled = 'true';
        }
      },
      true
    );

    document.addEventListener('DOMContentLoaded', () => {
      syncRecommendations();
      syncDiscountPresentation();
    });

    const drawer = document.querySelector('#cart-drawer');
    if (drawer) {
      new MutationObserver(() => {
        syncRecommendations();
        syncDiscountPresentation();
      }).observe(drawer, {
        childList: true,
        subtree: true,
      });
    }

    syncRecommendations();
    syncDiscountPresentation();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gkikz-product-critical-style"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__gkMainAtcPriceBound) return;
    window.__gkMainAtcPriceBound = true;

    const cleanText = (value) => (value || '').replace(/\s+/g, ' ').trim();
    const desktopProductQuery = window.matchMedia('(min-width: 1024px)');
    let desktopLayoutTimer;
    let desktopMediaObserver;
    let desktopMutationBusy = false;

    const textFrom = (node) => {
      if (!node) return '';
      const clone = node.cloneNode(true);
      clone.querySelectorAll(
        '[hidden], .visually-hidden, script, style, svg, .gk-main-atc-price, .compare-at-price, .price-item--regular, .gk-product-heading-compare'
      ).forEach((el) => el.remove());
      return cleanText(clone.textContent);
    };

    const roots = () => Array.from(new Set([
      document.querySelector('.product-information .product-details'),
      document.querySelector('.product-information'),
      document.querySelector('product-form-component')?.closest('.product-details'),
    ].filter(Boolean)));

    const priceText = () => {
      const selectors = [
        '.gk-product-heading-price',
        '.gk-product-heading-prices',
        'product-price [ref="priceContainer"] .price',
        'product-price [ref="priceContainer"]',
        'product-price .price',
        'product-price',
      ];

      for (const root of roots()) {
        for (const selector of selectors) {
          const text = textFrom(root.querySelector(selector));
          if (/\d/.test(text)) return text;
        }
      }

      for (const node of document.querySelectorAll(selectors.join(','))) {
        if (node.closest('[data-gkatc], cart-drawer, product-card, quick-add-modal')) continue;
        const text = textFrom(node);
        if (/\d/.test(text)) return text;
      }

      return '';
    };

    const mainButton = () => Array.from(document.querySelectorAll(
      '.product-details .product-form-buttons button[name="add"], .product-information .product-form-buttons button[name="add"], product-form-component button[name="add"]'
    )).find((button) => !button.closest('[data-gkatc], cart-drawer, product-card, quick-add-modal'));

    const copyClearanceCode = async (button) => {
      const code = 'CLEAR15';
      const codeLabel = button.querySelector('[data-gk-clearance-code]');
      const actionLabel = button.querySelector('[data-gk-clearance-action]');
      let copied = false;

      try {
        await navigator.clipboard.writeText(code);
        copied = true;
      } catch (error) {
        const input = document.createElement('textarea');
        input.value = code;
        input.setAttribute('readonly', '');
        input.style.position = 'fixed';
        input.style.opacity = '0';
        document.body.append(input);
        input.select();
        copied = document.execCommand('copy');
        input.remove();
      }

      if (!copied) return;
      window.clearTimeout(button._gkCopiedTimer);
      codeLabel.textContent = 'COPIED';
      actionLabel.hidden = true;
      button._gkCopiedTimer = window.setTimeout(() => {
        codeLabel.textContent = code;
        actionLabel.hidden = false;
      }, 1500);
    };

    const ensureClearanceOffer = () => {
      const content = document.querySelector(
        '.product-information .product-details > .group-block > .group-block-content'
      );
      if (!content || content.querySelector(':scope > .gk-clearance-offer')) return;

      const children = Array.from(content.children);
      const heading = children.find((node) => (
        node.querySelector('product-price')
        && node.querySelector('h1, [class*="product-title"], .product-title')
      ));
      const picker = children.find((node) => node.matches('variant-picker'));
      if (!picker) return;

      const offer = document.createElement('aside');
      offer.className = 'gk-clearance-offer';
      offer.setAttribute('aria-label', 'Clearance discount');
      offer.innerHTML = `
        <span class="gk-clearance-offer__text">
          <span class="gk-clearance-offer__eyebrow">Clearance deal</span>
          <span class="gk-clearance-offer__message">Extra 15% off sitewide</span>
        </span>
        <button class="gk-clearance-offer__copy" type="button" aria-label="Copy discount code CLEAR15">
          <span class="gk-clearance-offer__code" data-gk-clearance-code>CLEAR15</span>
          <span class="gk-clearance-offer__action" data-gk-clearance-action>COPY</span>
        </button>
      `;
      offer.querySelector('.gk-clearance-offer__copy')?.addEventListener('click', (event) => {
        copyClearanceCode(event.currentTarget);
      });

      if (heading?.parentElement === content) {
        heading.insertAdjacentElement('afterend', offer);
      } else {
        content.insertBefore(offer, picker);
      }
    };

    const updateCustomStickyState = () => {
      if (!document.body) return;
      document.body.classList.toggle('gk-custom-sticky-active', Boolean(document.querySelector('.gkatc')));
    };

    const decorate = () => {
      const button = mainButton();
      if (!button) return;

      button.classList.add('gk-main-atc-button');

      let label = button.querySelector('.gk-main-atc-label');
      let price = button.querySelector('.gk-main-atc-price');

      if (!label) {
        label = document.createElement('span');
        label.className = 'gk-main-atc-label';

        while (button.firstChild) label.append(button.firstChild);
        if (!textFrom(label)) label.textContent = 'ADD TO CART';
        button.append(label);
      }

      if (!price) {
        price = document.createElement('span');
        price.className = 'gk-main-atc-price';
        price.setAttribute('aria-hidden', 'true');
        button.append(price);
      }

      const labelText = textFrom(label);
      if (!labelText || /^add( to cart)?$/i.test(labelText)) label.textContent = 'ADD TO CART';

      const currentPrice = priceText();
      price.textContent = currentPrice;
      price.hidden = !currentPrice;
    };

    const restoreMovedNode = (node) => {
      const placeholder = node?._gkDesktopPlaceholder;
      if (placeholder?.isConnected && placeholder.parentNode) {
        placeholder.parentNode.insertBefore(node, placeholder);
        placeholder.remove();
      }
      if (node) {
        node._gkDesktopPlaceholder = null;
        node.classList.remove('gk-pdp-moved', 'gk-pdp-rail__heading', 'gk-pdp-rail__accordion');
      }
    };

    const clearDesktopMediaObserver = () => {
      if (desktopMediaObserver) desktopMediaObserver.disconnect();
      desktopMediaObserver = null;
    };

    const cleanupDesktopLayout = () => {
      clearDesktopMediaObserver();
      document.querySelectorAll('.product-information__media media-gallery[data-gk-variant-media-key]').forEach((gallery) => {
        if (gallery._gkVariantMediaFrame) {
          window.cancelAnimationFrame(gallery._gkVariantMediaFrame);
          gallery._gkVariantMediaFrame = null;
        }
        gallery.style.removeProperty('scroll-snap-type');
        gallery.style.removeProperty('scroll-behavior');
        delete gallery.dataset.gkVariantMediaKey;
      });
      document.querySelectorAll('.gk-pdp-editorial-rail .gk-pdp-moved').forEach(restoreMovedNode);
      document.querySelectorAll('.gk-pdp-editorial-rail, .gk-pdp-thumbnails').forEach((node) => node.remove());
      document.querySelectorAll('.gk-pdp-desktop-layout').forEach((node) => {
        node.classList.remove('gk-pdp-desktop-layout');
      });
    };

    const moveToRail = (node, rail, railClass) => {
      if (!node || node.parentElement === rail) return;

      const staleNode = rail.querySelector(`.${railClass}`);
      if (staleNode && staleNode !== node) {
        restoreMovedNode(staleNode);
        staleNode.remove();
      }

      if (!node._gkDesktopPlaceholder && node.parentNode) {
        const placeholder = document.createComment(`gk-origin-${railClass}`);
        node.parentNode.insertBefore(placeholder, node);
        node._gkDesktopPlaceholder = placeholder;
      }

      node.classList.add('gk-pdp-moved', railClass);
      rail.append(node);
    };

    const decorateDesktopColorOptions = (details) => {
      const picker = details?.querySelector('variant-picker');
      const colorFieldset = picker?.querySelector(
        'fieldset.variant-option:has(input[data-option-name="Color"]), fieldset.variant-option:has(input[data-option-name="Colour"])'
      );
      if (!colorFieldset) return;

      let swatchMap = {};
      try {
        swatchMap = JSON.parse(document.querySelector('[data-gkatc-swatch-map]')?.textContent || '{}');
      } catch (error) {}

      colorFieldset.classList.add('gk-color-option');

      const legend = colorFieldset.querySelector('legend');
      let selectedValue = legend?.querySelector('.gk-selected-option-value');
      if (legend && !selectedValue) {
        selectedValue = document.createElement('span');
        selectedValue.className = 'gk-selected-option-value';
        legend.append(selectedValue);
      }

      const checked = colorFieldset.querySelector('input[type="radio"]:checked');
      if (selectedValue) selectedValue.textContent = checked?.value || '';

      colorFieldset.querySelectorAll(':scope > .variant-option__button-label').forEach((label) => {
        const input = label.querySelector('input[type="radio"]');
        const imageUrl = swatchMap[input?.value || ''];
        if (!imageUrl) return;
        label.dataset.gkSwatchImage = 'true';
        label.style.setProperty('--gk-option-image', `url(${JSON.stringify(imageUrl)})`);
      });
    };

    const buildDesktopThumbnails = (grid, media, gallery) => {
      const items = Array.from(grid.children).filter((item) => item.matches('.product-media-container'));
      const signature = items.map((item) => item.querySelector('img')?.currentSrc || item.dataset.mediaId || '').join('|');
      let thumbnails = media.querySelector(':scope > .gk-pdp-thumbnails');

      if (items.length < 2) {
        thumbnails?.remove();
        clearDesktopMediaObserver();
        return;
      }

      if (thumbnails?.dataset.signature === signature) return;

      thumbnails?.remove();
      clearDesktopMediaObserver();

      thumbnails = document.createElement('nav');
      thumbnails.className = 'gk-pdp-thumbnails';
      thumbnails.dataset.signature = signature;
      thumbnails.setAttribute('aria-label', 'Product images');

      const buttons = items.map((item, index) => {
        const sourceImage = item.querySelector('img');
        const button = document.createElement('button');
        const image = document.createElement('img');

        button.type = 'button';
        button.className = 'gk-pdp-thumbnail';
        button.setAttribute('aria-label', `View product image ${index + 1}`);
        button.setAttribute('aria-current', index === 0 ? 'true' : 'false');
        image.alt = '';
        image.loading = 'lazy';
        image.src = sourceImage?.currentSrc || sourceImage?.src || '';
        button.append(image);
        button.addEventListener('click', () => {
          gallery.scrollTo({ top: item.offsetTop, behavior: 'smooth' });
        });
        thumbnails.append(button);
        return button;
      });

      media.append(thumbnails);

      desktopMediaObserver = new IntersectionObserver((entries) => {
        const visible = entries
          .filter((entry) => entry.isIntersecting)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
        if (!visible) return;
        const activeIndex = items.indexOf(visible.target);
        buttons.forEach((button, index) => {
          button.setAttribute('aria-current', index === activeIndex ? 'true' : 'false');
        });
        buttons[activeIndex]?.scrollIntoView({ block: 'nearest' });
      }, {
        root: gallery,
        threshold: [0.45, 0.7],
      });

      items.forEach((item) => desktopMediaObserver.observe(item));
    };

    const scrollDesktopGalleryToVariant = (details, grid, gallery) => {
      let swatchMap = {};
      let selectedVariant;
      try {
        swatchMap = JSON.parse(document.querySelector('[data-gkatc-swatch-map]')?.textContent || '{}');
        selectedVariant = JSON.parse(
          details.querySelector('variant-picker script[type="application/json"]')?.textContent || 'null'
        );
      } catch (error) {
        selectedVariant = null;
      }

      const selectedColor = details.querySelector(
        'fieldset.variant-option:has(input[data-option-name="Color"]) input[type="radio"]:checked,'
        + ' fieldset.variant-option:has(input[data-option-name="Colour"]) input[type="radio"]:checked'
      )?.value || '';
      const swatchImage = swatchMap[selectedColor] || '';
      let swatchPath = '';
      try {
        swatchPath = new URL(swatchImage, window.location.href).pathname;
      } catch (error) {}

      const mediaId = String(
        selectedVariant?.featured_media?.id
        || selectedVariant?.featured_image?.id
        || ''
      );
      const items = Array.from(grid.children).filter((item) => item.matches('.product-media-container'));
      let target = swatchPath
        ? items.find((item) => {
          const image = item.querySelector('img');
          try {
            return new URL(image?.currentSrc || image?.src || '', window.location.href).pathname === swatchPath;
          } catch (error) {
            return false;
          }
        })
        : null;

      if (!target && mediaId) {
        target = items.find((item) => (
          Array.from(item.querySelectorAll('[data-media-id]')).some(
            (mediaNode) => mediaNode.dataset.mediaId === mediaId
          )
        ));
      }
      if (!target) return;

      const mediaKey = swatchPath ? `image:${swatchPath}` : `media:${mediaId}`;
      if (gallery.dataset.gkVariantMediaKey === mediaKey) return;

      const behavior = gallery.dataset.gkVariantMediaKey ? 'smooth' : 'auto';
      gallery.dataset.gkVariantMediaKey = mediaKey;
      if (behavior === 'auto') {
        gallery.scrollTo({ top: target.offsetTop, behavior });
        return;
      }

      if (gallery._gkVariantMediaFrame) {
        window.cancelAnimationFrame(gallery._gkVariantMediaFrame);
      }

      const start = gallery.scrollTop;
      const destination = target.offsetTop;
      const distance = destination - start;
      const duration = 420;
      let startedAt;

      gallery.style.setProperty('scroll-snap-type', 'none', 'important');
      gallery.style.setProperty('scroll-behavior', 'auto', 'important');

      const animate = (timestamp) => {
        startedAt ??= timestamp;
        const progress = Math.min((timestamp - startedAt) / duration, 1);
        const eased = 1 - Math.pow(1 - progress, 3);
        gallery.scrollTop = start + (distance * eased);

        if (progress < 1) {
          gallery._gkVariantMediaFrame = window.requestAnimationFrame(animate);
          return;
        }

        gallery.scrollTop = destination;
        gallery._gkVariantMediaFrame = null;
        gallery.style.removeProperty('scroll-snap-type');
        gallery.style.removeProperty('scroll-behavior');
      };

      gallery._gkVariantMediaFrame = window.requestAnimationFrame(animate);
    };

    const applyDesktopProductLayout = () => {
      if (!desktopProductQuery.matches) {
        cleanupDesktopLayout();
        return;
      }

      const productGrid = document.querySelector(
        '.product-information product-component[data-product-grid-content]'
      );
      const media = productGrid?.querySelector(':scope > .product-information__media');
      const details = productGrid?.querySelector(':scope > .product-details');
      const content = details?.querySelector(':scope > .group-block > .group-block-content');
      const gallery = media?.querySelector('media-gallery');
      const grid = gallery?.querySelector('.media-gallery__grid');

      if (!productGrid || !media || !details || !content || !gallery || !grid) return;

      desktopMutationBusy = true;
      productGrid.classList.add('gk-pdp-desktop-layout');

      let rail = productGrid.querySelector(':scope > .gk-pdp-editorial-rail');
      if (!rail) {
        rail = document.createElement('aside');
        rail.className = 'gk-pdp-editorial-rail';
        rail.setAttribute('aria-label', 'Product information');
        productGrid.insertBefore(rail, media);
      }

      const contentChildren = Array.from(content.children);
      const heading = contentChildren.find((node) => (
        node.querySelector('product-price')
        && node.querySelector('h1, [class*="product-title"], .product-title')
      ));
      const accordion = contentChildren.find((node) => node.matches('.accordion'));

      moveToRail(heading, rail, 'gk-pdp-rail__heading');
      moveToRail(accordion, rail, 'gk-pdp-rail__accordion');
      decorateDesktopColorOptions(details);
      buildDesktopThumbnails(grid, media, gallery);
      scrollDesktopGalleryToVariant(details, grid, gallery);

      window.requestAnimationFrame(() => {
        desktopMutationBusy = false;
      });
    };

    const scheduleDesktopProductLayout = () => {
      window.clearTimeout(desktopLayoutTimer);
      desktopLayoutTimer = window.setTimeout(applyDesktopProductLayout, 60);
    };

    let timer;
    const schedule = () => {
      updateCustomStickyState();
      window.clearTimeout(timer);
      timer = window.setTimeout(() => {
        ensureClearanceOffer();
        decorate();
        updateCustomStickyState();
      }, 80);
    };

    const footerSelector = 'footer, .shopify-section-group-footer-group, [id*="shopify-section-footer"], [id*="__footer"], .footer';
    let footerTimer;
    let footerObserver;
    let observedFooter;

    const footerElement = () => document.querySelector(footerSelector);

    const footerIsVisible = () => {
      const footer = footerElement();
      if (!footer) return false;
      const rect = footer.getBoundingClientRect();
      return rect.top < window.innerHeight && rect.bottom > 0;
    };

    const updateFooterState = () => {
      if (!document.body) return;
      document.body.classList.toggle('gk-product-footer-visible', footerIsVisible());
    };

    const watchFooter = () => {
      updateCustomStickyState();
      const footer = footerElement();
      if (!footer || footer === observedFooter) {
        updateFooterState();
        return;
      }

      observedFooter = footer;
      if (footerObserver) footerObserver.disconnect();
      footerObserver = new IntersectionObserver((entries) => {
        const visible = entries.some((entry) => entry.isIntersecting || (entry.boundingClientRect.top < window.innerHeight && entry.boundingClientRect.bottom > 0));
        document.body.classList.toggle('gk-product-footer-visible', visible);
        updateCustomStickyState();
      }, { threshold: 0, rootMargin: '0px' });
      footerObserver.observe(footer);
      updateFooterState();
    };

    const scheduleFooter = () => {
      window.clearTimeout(footerTimer);
      footerTimer = window.setTimeout(watchFooter, 40);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        schedule();
        scheduleFooter();
        scheduleDesktopProductLayout();
      }, { once: true });
    } else {
      schedule();
      scheduleFooter();
      scheduleDesktopProductLayout();
    }

    document.addEventListener('change', schedule, true);
    document.addEventListener('change', scheduleDesktopProductLayout, true);
    document.addEventListener('input', schedule, true);
    document.addEventListener('click', () => {
      schedule();
      scheduleFooter();
      scheduleDesktopProductLayout();
    }, true);
    document.addEventListener('shopify:section:load', () => {
      schedule();
      scheduleFooter();
      scheduleDesktopProductLayout();
    });
    window.addEventListener('scroll', scheduleFooter, { passive: true });
    window.addEventListener('resize', () => {
      scheduleFooter();
      scheduleDesktopProductLayout();
    }, { passive: true });
    desktopProductQuery.addEventListener('change', scheduleDesktopProductLayout);

    try {
      new MutationObserver(() => {
        schedule();
        scheduleFooter();
        if (!desktopMutationBusy) scheduleDesktopProductLayout();
      }).observe(document.querySelector('main') || document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'hidden', 'disabled', 'aria-disabled', 'checked', 'value'],
      });
    } catch (error) {}
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gkikz-sticky-atc"] && !Shopify.designMode) return;
  try {
    (() => {
      const bars = document.querySelectorAll('[data-gkatc]');
      if (!bars.length) return;

      const cleanText = (value) => (value || '').replace(/\s+/g, ' ').trim();
      const swatchMapNode = document.querySelector('[data-gkatc-swatch-map]');
      let swatchImageMap = {};

      try {
        swatchImageMap = JSON.parse(swatchMapNode?.textContent || '{}');
      } catch (error) {
        swatchImageMap = {};
      }

      const cssImageUrl = (value) => `url("${String(value).replace(/\\/g, '\\\\').replace(/"/g, '\\"')}")`;

      bars.forEach((bar) => {
        if (bar.dataset.gkatcReady === 'true') return;
        bar.dataset.gkatcReady = 'true';

        const button = bar.querySelector('[data-gkatc-button]');
        const buttonLabel = bar.querySelector('[data-gkatc-button-label]');
        const optionTarget = bar.querySelector('[data-gkatc-options]');
        const separator = bar.querySelector('[data-gkatc-separator]');
        const priceTarget = bar.querySelector('[data-gkatc-price]');
        const variantControls = bar.querySelector('[data-gkatc-variant-controls]');
        const addLabel = bar.dataset.gkatcAddLabel || cleanText(buttonLabel?.textContent) || 'Add to cart';
        const mediaQuery = window.matchMedia('(max-width: 749px)');
        let mainButton = null;
        let observer = null;
        let hideTimer = null;
        let syncTimer = null;
        let controlsSignature = '';
        let frameRequested = false;

        if (!button || !buttonLabel || !optionTarget || !separator || !priceTarget || !variantControls) return;

        const getMainButton = () => {
          const selectors = [
            'product-form-component [ref="addToCartButton"]',
            'product-form-component add-to-cart-component button[type="submit"]',
            'form[action*="/cart/add"] button[type="submit"][name="add"]',
          ];
          const buttons = Array.from(document.querySelectorAll(selectors.join(',')));
          return buttons.find((candidate) => {
            return !candidate.closest('[data-gkatc]') && !candidate.closest('product-card') && !candidate.closest('quick-add-modal');
          }) || null;
        };

        const getMainVariantPicker = () => {
          const pickers = Array.from(document.querySelectorAll('variant-picker'));
          return pickers.find((picker) => {
            return !picker.closest('[data-gkatc]') && !picker.closest('product-card') && !picker.closest('quick-add-modal');
          }) || null;
        };

        const escapeSelectorValue = (value) => {
          if (window.CSS && typeof window.CSS.escape === 'function') return window.CSS.escape(value);
          return String(value).replace(/["\\]/g, '\\$&');
        };

        const cloneTextWithoutHidden = (node) => {
          if (!node) return '';
          const clone = node.cloneNode(true);
          clone
            .querySelectorAll(
              '.visually-hidden, [hidden], script, style, .compare-at-price, .variant-option__swatch-value, .gksc-link, .gk-selected-option-value'
            )
            .forEach((child) => {
            child.remove();
          });
          return cleanText(clone.textContent);
        };

        const cleanPriceText = (value) => {
          return cleanText(value)
            .replace(/\b(?:regular|sale|current|compare at|unit)\s+price\b:?/gi, '')
            .replace(/\s+/g, ' ')
            .trim();
        };

        const colorTokens = [
          { test: /black|noir|charcoal|shadow/i, rgb: '18 18 18' },
          { test: /white|ivory|snow/i, rgb: '238 235 228' },
          { test: /cream|ecru|natural|oat/i, rgb: '218 203 178' },
          { test: /beige|sand|tan|khaki/i, rgb: '190 162 124' },
          { test: /brown|chocolate|coffee|mocha|selena/i, rgb: '100 61 45' },
          { test: /orange|rust|copper|terracotta/i, rgb: '210 104 38' },
          { test: /green|olive|sage|mint/i, rgb: '87 104 72' },
          { test: /pink|rose|blush/i, rgb: '218 135 155' },
          { test: /blue|navy|cobalt|denim/i, rgb: '58 91 130' },
          { test: /grey|gray|silver|ash/i, rgb: '142 142 142' },
          { test: /red|burgundy|maroon|wine/i, rgb: '143 39 43' },
          { test: /yellow|gold|mustard/i, rgb: '218 165 44' },
          { test: /purple|violet|lavender/i, rgb: '131 92 154' },
        ];

        const isColorOptionName = (name) => /colou?r/i.test(cleanText(name));

        const rgbForColorName = (value) => {
          const text = cleanText(value);
          const match = colorTokens.find((token) => token.test.test(text));
          return match ? match.rgb : '128 118 106';
        };

        const decorateProductColorOptions = () => {
          const picker = getMainVariantPicker();
          if (!picker) return;

          picker.querySelectorAll('fieldset.variant-option').forEach((fieldset) => {
            const legend = fieldset.querySelector('legend');
            const isColor = isColorOptionName(cloneTextWithoutHidden(legend));
            const selectedInput = fieldset.querySelector('input[type="radio"]:checked');
            const selectedValue = cleanText(selectedInput?.value || selectedInput?.getAttribute('aria-label'));
            fieldset.classList.toggle('gk-color-option', isColor);

            const selectedValueNode = legend?.querySelector('.gk-selected-option-value');
            if (isColor && legend && selectedValue) {
              const node = selectedValueNode || document.createElement('span');
              node.className = 'gk-selected-option-value';
              node.textContent = selectedValue;
              if (!selectedValueNode) legend.append(node);
            } else {
              selectedValueNode?.remove();
            }

            if (!isColor) return;

            fieldset.querySelectorAll('.variant-option__button-label').forEach((label) => {
              const input = label.querySelector('input[type="radio"]');
              const value = input?.value || input?.getAttribute('aria-label') || label.textContent;
              const imageUrl = swatchImageMap[value];

              label.style.setProperty('--gk-option-rgb', rgbForColorName(value));
              if (imageUrl) {
                label.dataset.gkSwatchImage = 'true';
                label.style.setProperty('--gk-option-image', cssImageUrl(imageUrl));
              } else {
                delete label.dataset.gkSwatchImage;
                label.style.removeProperty('--gk-option-image');
              }
            });
          });
        };

        const getMainProductRoots = () => {
          const roots = [];
          const addRoot = (root) => {
            if (!root || roots.includes(root)) return;
            if (root.closest?.('[data-gkatc], product-card, quick-add-modal, cart-drawer')) return;
            roots.push(root);
          };

          addRoot(mainButton?.closest('.product-details'));
          addRoot(mainButton?.closest('.product-information'));
          addRoot(getMainVariantPicker()?.closest('.product-details'));
          addRoot(getMainVariantPicker()?.closest('.product-information'));
          addRoot(document.querySelector('.product-information .product-details'));
          addRoot(document.querySelector('.product-information'));
          addRoot(document.querySelector('product-form-component')?.closest('.product-details'));

          return roots;
        };

        const getPrice = () => {
          const selectors = [
            'product-price [ref="priceContainer"] .price-item__group.price',
            'product-price [ref="priceContainer"] > .price',
            'product-price .price-item__group.price',
            'product-price .price',
          ];

          for (const root of getMainProductRoots()) {
            for (const selector of selectors) {
              const node = root.querySelector(selector);
              const text = cloneTextWithoutHidden(node);
              if (/\d/.test(text)) return text;
            }
          }

          const fallbackNodes = Array.from(document.querySelectorAll(selectors.join(',')));
          for (const node of fallbackNodes) {
            if (node.closest('[data-gkatc], product-card, quick-add-modal, cart-drawer')) continue;
            const text = cloneTextWithoutHidden(node);
            if (/\d/.test(text)) return text;
          }

          return cleanText(priceTarget.textContent);
        };

        const getProductDetailsRoot = () => {
          return getMainProductRoots().find((root) => root.matches?.('.product-details')) || document.querySelector('.product-information .product-details');
        };

        const getDirectChildFor = (container, node) => {
          let child = node;
          while (child && child.parentElement !== container) {
            child = child.parentElement;
          }
          return child || node;
        };

        const decorateProductHeadingRow = () => {
          const detailsRoot = getProductDetailsRoot();
          if (!detailsRoot) return;

          const titleNode = detailsRoot.querySelector('h1');
          const priceNode = detailsRoot.querySelector('product-price');
          if (!titleNode || !priceNode) return;

          let content = titleNode.closest('.group-block-content');
          if (!content || !content.contains(priceNode)) content = priceNode.closest('.group-block-content');
          if (!content || !content.contains(titleNode)) content = detailsRoot.querySelector('.group-block-content') || detailsRoot;
          if (!content.contains(titleNode) || !content.contains(priceNode)) return;

          let row = content.querySelector(':scope > [data-gk-product-heading-row]');
          if (!row) {
            row = document.createElement('div');
            row.className = 'gk-product-heading-row';
            row.dataset.gkProductHeadingRow = 'true';
            row.setAttribute('aria-hidden', 'true');
          }

          const titleShell = getDirectChildFor(content, titleNode);
          const priceShell = getDirectChildFor(content, priceNode);
          if (row.parentElement !== content) {
            content.insertBefore(row, titleShell && titleShell !== row ? titleShell : content.firstElementChild);
          }

          detailsRoot.querySelectorAll('.gk-product-heading-source').forEach((source) => {
            source.classList.remove('gk-product-heading-source');
          });

          const markSource = (shell, fallback) => {
            const source = shell && shell !== row && shell !== content && shell !== detailsRoot ? shell : fallback;
            if (!source || source === row || row.contains(source)) return;
            if (source.querySelector?.('variant-picker, product-form-component, .product-form-buttons')) {
              fallback.classList.add('gk-product-heading-source');
              return;
            }
            source.classList.add('gk-product-heading-source');
          };

          markSource(titleShell, titleNode);
          markSource(priceShell, priceNode);

          const titleText = cleanText(titleNode.textContent);
          const currentPriceText = cleanPriceText(cloneTextWithoutHidden(
            priceNode.querySelector('[ref="priceContainer"] .price') || priceNode.querySelector('.price') || priceNode
          ));
          const comparePriceText = cleanPriceText(cloneTextWithoutHidden(priceNode.querySelector('.compare-at-price')));
          if (!titleText || !currentPriceText) return;

          const title = document.createElement('span');
          title.className = 'gk-product-heading-title';
          title.textContent = titleText;

          const prices = document.createElement('span');
          prices.className = 'gk-product-heading-prices';

          const currentPrice = document.createElement('span');
          currentPrice.className = 'gk-product-heading-price';
          currentPrice.textContent = currentPriceText;
          prices.append(currentPrice);

          if (comparePriceText) {
            const comparePrice = document.createElement('span');
            comparePrice.className = 'gk-product-heading-compare';
            comparePrice.textContent = comparePriceText;
            prices.append(comparePrice);
          }

          row.replaceChildren(title, prices);
          detailsRoot.classList.add('gk-product-heading-ready');
        };

        const decorateProductLowerContent = () => {
          const root = getMainProductRoots()[0];
          if (!root) return;

          const formButtons = root.querySelector('.product-form-buttons');
          if (!formButtons) return;

          root.querySelectorAll('[data-gk-product-trust]').forEach((trust) => trust.remove());

          const hasTrustCopy = (text) => {
            return /worldwide shipping/i.test(text) || /hassle[-\s]?free returns/i.test(text) || /premium quality/i.test(text);
          };

          Array.from(root.querySelectorAll('.gk-product-trust-source')).forEach((element) => {
            element.classList.remove('gk-product-trust-source');
          });

          Array.from(root.querySelectorAll('.gk-product-trust-copy')).forEach((element) => {
            element.classList.remove('gk-product-trust-copy');
          });

          let trustCopy = null;
          Array.from(root.querySelectorAll('p, li, div, span')).forEach((element) => {
            if (element.closest('[data-gk-product-trust]')) return;
            const text = cleanText(element.textContent);
            if (!text || text.length > 260 || !hasTrustCopy(text)) return;
            const childHasTrustCopy = Array.from(element.children).some((child) => hasTrustCopy(cleanText(child.textContent)));
            if (!childHasTrustCopy && !trustCopy) trustCopy = element;
          });

          if (!trustCopy) {
            let sibling = formButtons.nextElementSibling;
            while (sibling && sibling.tagName?.toLowerCase() !== 'details') {
              const text = cleanText(sibling.textContent);
              if (text && !sibling.matches('[data-gk-product-trust], script, style')) {
                trustCopy = sibling;
                break;
              }
              sibling = sibling.nextElementSibling;
            }
          }

          if (trustCopy) trustCopy.classList.add('gk-product-trust-copy');

          root.querySelectorAll('details').forEach((details) => {
            if (details.closest('[data-gkatc], .gksc-modal, dialog, modal-dialog, quick-add-modal')) return;
            const summary = details.querySelector('summary');
            if (!summary) return;

            const text = cleanText(summary.textContent).toLowerCase();
            let label = '';
            if (text.includes('description') || text.includes('laundry') || text.includes('size chart')) {
              label = 'Product details';
            } else if (text.includes('shipping')) {
              label = 'Shipping & returns';
            }

            if (!label) return;
            details.classList.add('gk-product-accordion');
            summary.classList.add('gk-product-summary');
            summary.dataset.gkLabel = label;
          });
        };

        const getButtonText = () => {
          const text = cloneTextWithoutHidden(mainButton);
          if (!text) return addLabel;
          return text.replace(/\s*added\s*$/i, '').trim() || addLabel;
        };

        const getOptions = () => {
          const values = [];
          const fieldsets = new Set(
            Array.from(
              document.querySelectorAll('variant-picker fieldset, .variant-picker fieldset, fieldset.variant-option')
            )
          );

          fieldsets.forEach((fieldset) => {
            if (fieldset.closest('[data-gkatc], product-card, quick-add-modal, cart-drawer')) return;
            const checked = fieldset.querySelector('input[type="radio"]:checked');
            const value = cleanText(checked?.value || checked?.getAttribute('aria-label'));
            if (value && value !== 'Default Title') values.push(value);
          });

          if (!values.length) {
            document.querySelectorAll('variant-picker select, form[action*="/cart/add"] select[name^="options"]').forEach((select) => {
              if (select.closest('[data-gkatc], product-card, quick-add-modal, cart-drawer')) return;
              const value = cleanText(select.options?.[select.selectedIndex]?.text || select.value);
              if (value && value !== 'Default Title') values.push(value);
            });
          }

          return values.join(' / ');
        };

        const readVariantGroups = () => {
          const picker = getMainVariantPicker();
          if (!picker) return [];
          const groups = [];

          picker.querySelectorAll('fieldset.variant-option').forEach((fieldset) => {
            const label = cloneTextWithoutHidden(fieldset.querySelector('legend'));
            const options = Array.from(fieldset.querySelectorAll('input[type="radio"]'))
              .filter((input) => input.dataset.optionName)
              .map((input) => {
                return {
                  optionValueId: input.dataset.optionValueId || '',
                  value: cleanText(input.value || input.getAttribute('aria-label')),
                  selected: input.checked || input.dataset.currentChecked === 'true',
                  unavailable: input.dataset.optionAvailable === 'false' || input.getAttribute('aria-disabled') === 'true',
                  disabled: input.disabled,
                };
              })
              .filter((option) => option.value && option.value !== 'Default Title');

            if (label && options.length) groups.push({ name: label, type: 'radio', options });
          });

          picker.querySelectorAll('.variant-option--dropdowns').forEach((group) => {
            const select = group.querySelector('select');
            if (!select) return;
            const label = cloneTextWithoutHidden(group.querySelector('label'));
            const options = Array.from(select.options)
              .map((option) => {
                return {
                  optionValueId: option.dataset.optionValueId || '',
                  value: cleanText(option.value || option.textContent),
                  selected: option.selected,
                  unavailable: /unavailable|sold out/i.test(option.textContent || ''),
                  disabled: option.disabled,
                };
              })
              .filter((option) => option.value && option.value !== 'Default Title');

            if (label && options.length) groups.push({ name: label, type: 'select', options });
          });

          return groups;
        };

        const renderVariantControls = () => {
          const groups = readVariantGroups();
          const signature = groups
            .map((group) => {
              return `${group.name}:${group.options
                .map((option) => `${option.optionValueId}:${option.value}:${option.selected}:${option.unavailable}:${option.disabled}`)
                .join('|')}`;
            })
            .join('||');

          if (!groups.length) {
            controlsSignature = '';
            variantControls.replaceChildren();
            variantControls.hidden = true;
            variantControls.removeAttribute('data-option-count');
            return;
          }

          if (signature === controlsSignature) return;
          controlsSignature = signature;
          variantControls.replaceChildren();
          variantControls.hidden = false;
          variantControls.dataset.optionCount = String(groups.length);

          groups.forEach((group) => {
            const field = document.createElement('label');
            field.className = 'gkatc__select';

            const selectedOption = group.options.find((option) => option.selected) || group.options[0];
            if (isColorOptionName(group.name) && selectedOption) {
              field.dataset.optionRole = 'color';
              field.style.setProperty('--gk-sticky-color', rgbForColorName(selectedOption.value));
            }

            const label = document.createElement('span');
            label.className = 'gkatc__select-label';
            label.textContent = group.name;
            field.append(label);

            const select = document.createElement('select');
            select.className = 'gkatc__select-control';
            select.setAttribute('aria-label', group.name);

            group.options.forEach((option) => {
              const selectOption = document.createElement('option');
              selectOption.value = option.value;
              selectOption.textContent = option.unavailable ? `${option.value} - Sold out` : option.value;
              selectOption.dataset.optionName = group.name;
              selectOption.dataset.optionValue = option.value;
              selectOption.dataset.optionValueId = option.optionValueId;
              selectOption.dataset.optionUnavailable = option.unavailable ? 'true' : 'false';
              selectOption.selected = option.selected;
              selectOption.disabled = option.disabled;
              select.append(selectOption);
            });

            field.append(select);
            variantControls.append(field);
          });
        };

        const findSourceOption = (chip) => {
          const picker = getMainVariantPicker();
          if (!picker) return null;
          const optionValueId = chip.dataset.optionValueId;
          const optionName = chip.dataset.optionName;
          const optionValue = chip.dataset.optionValue;

          if (optionValueId) {
            const exact = picker.querySelector(`[data-option-value-id="${escapeSelectorValue(optionValueId)}"]`);
            if (exact) return exact;
          }

          const sourceOptions = Array.from(picker.querySelectorAll('input[type="radio"], option'));
          return sourceOptions.find((source) => {
            const sourceName = source.dataset.optionName;
            const sourceValue = cleanText(source.value || source.textContent);
            return sourceName === optionName && sourceValue === optionValue;
          }) || null;
        };

        const activateStickyOption = (chip) => {
          const source = findSourceOption(chip);
          if (!source || source.disabled) return;

          if (source instanceof HTMLOptionElement) {
            const select = source.parentElement;
            if (!(select instanceof HTMLSelectElement)) return;
            select.value = source.value;
            select.dispatchEvent(new Event('change', { bubbles: true }));
            return;
          }

          if (source instanceof HTMLInputElement) {
            source.click();
            if (!source.checked) {
              source.checked = true;
              source.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }
        };

        const hasOpenOverlay = () => {
          return Boolean(
            document.querySelector(
              'dialog[open], cart-drawer[open], theme-drawer[open], .cart-drawer.is-open, .drawer[open], .modal[open]'
            )
          );
        };

        const updateHeight = () => {
          const restoreHidden = bar.hidden;
          if (restoreHidden) {
            bar.hidden = false;
            bar.style.visibility = 'hidden';
            bar.style.pointerEvents = 'none';
          }

          document.documentElement.style.setProperty('--gkatc-height', `${Math.ceil(bar.offsetHeight)}px`);

          if (restoreHidden) {
            bar.hidden = true;
            bar.style.visibility = '';
            bar.style.pointerEvents = '';
          }
        };

        const sync = () => {
          mainButton = getMainButton();
          decorateProductColorOptions();
          renderVariantControls();
          decorateProductHeadingRow();
          decorateProductLowerContent();
          const options = getOptions();
          optionTarget.textContent = options;
          optionTarget.hidden = !options;
          separator.hidden = !options;
          priceTarget.textContent = getPrice();

          if (mainButton) {
            const disabled = mainButton.disabled || mainButton.getAttribute('aria-disabled') === 'true';
            button.disabled = disabled;
            buttonLabel.textContent = disabled ? getButtonText() : addLabel;
          }

          updateHeight();
        };

        const show = () => {
          window.clearTimeout(hideTimer);
          if (bar.hidden) bar.hidden = false;
          updateHeight();
          bar.setAttribute('aria-hidden', 'false');
          document.documentElement.classList.add('gkatc-is-visible');
          window.requestAnimationFrame(() => bar.classList.add('is-visible'));
        };

        const hide = () => {
          bar.classList.remove('is-visible');
          bar.setAttribute('aria-hidden', 'true');
          document.documentElement.classList.remove('gkatc-is-visible');
          window.clearTimeout(hideTimer);
          hideTimer = window.setTimeout(() => {
            if (!bar.classList.contains('is-visible')) bar.hidden = true;
          }, 220);
        };

        const mainButtonIsInView = () => {
          if (!mainButton) return true;
          const rect = mainButton.getBoundingClientRect();
          return rect.top < window.innerHeight - 8 && rect.bottom > 88;
        };

        const updateVisibility = () => {
          sync();
          if (!mediaQuery.matches || hasOpenOverlay() || !mainButton || mainButtonIsInView()) {
            hide();
          } else {
            show();
          }
        };

        const scheduleSync = () => {
          window.clearTimeout(syncTimer);
          syncTimer = window.setTimeout(updateVisibility, 90);
        };

        const requestUpdate = () => {
          if (frameRequested) return;
          frameRequested = true;
          window.requestAnimationFrame(() => {
            frameRequested = false;
            updateVisibility();
          });
        };

        const refreshObserver = () => {
          const nextButton = getMainButton();
          if (nextButton === mainButton && observer) return;
          mainButton = nextButton;
          if (observer) observer.disconnect();
          if (!mainButton || !('IntersectionObserver' in window)) return;
          observer = new IntersectionObserver(updateVisibility, {
            root: null,
            rootMargin: '0px 0px 24px 0px',
            threshold: [0, 0.5, 1],
          });
          observer.observe(mainButton);
        };

        variantControls.addEventListener('click', (event) => {
          const target = event.target instanceof Element ? event.target : null;
          const chip = target?.closest('.gkatc__chip');
          if (!chip || !variantControls.contains(chip)) return;
          activateStickyOption(chip);
          scheduleSync();
        });

        variantControls.addEventListener('change', (event) => {
          const select = event.target instanceof HTMLSelectElement ? event.target : null;
          const selectedOption = select?.options[select.selectedIndex];
          if (!select || !selectedOption) return;
          activateStickyOption(selectedOption);
          scheduleSync();
        });

        button.addEventListener('click', () => {
          sync();
          if (!mainButton || button.disabled) {
            const productArea = document.querySelector('product-form-component') || document.querySelector('.product-information');
            productArea?.scrollIntoView({ behavior: 'smooth', block: 'center' });
            return;
          }
          mainButton.click();
        });

        document.addEventListener('change', scheduleSync, true);
        document.addEventListener('input', scheduleSync, true);
        document.addEventListener('click', scheduleSync, true);
        window.addEventListener('scroll', requestUpdate, { passive: true });
        window.addEventListener('resize', scheduleSync, { passive: true });

        if (typeof mediaQuery.addEventListener === 'function') {
          mediaQuery.addEventListener('change', scheduleSync);
        } else if (typeof mediaQuery.addListener === 'function') {
          mediaQuery.addListener(scheduleSync);
        }

        const main = document.querySelector('main') || document.body;
        const mutationObserver = new MutationObserver(() => {
          refreshObserver();
          scheduleSync();
        });
        mutationObserver.observe(main, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['disabled', 'aria-disabled', 'class', 'hidden', 'checked', 'value'],
        });

        refreshObserver();
        updateVisibility();
      });
    })();
  } catch(e) { console.error(e); }
})();

})();
